export default __webpack_public_path__ + "static/media/Single_Arrow_Black.25fe3425.svg";